(function () {
  function isInteractive(target) {
    return !!target.closest(
      'form, button, input, quantity-selector-component, add-to-cart-component, .add-to-cart-button'
    );
  }

  function isInsideRefinedCard(target) {
    return !!target.closest('.refined-product-card');
  }

  function getInput(selector) {
    return selector instanceof Element
      ? selector.querySelector('input[type="number"]')
      : null;
  }

  function getStep(input) {
    const step = parseFloat(input.getAttribute('step') || '1');
    return Number.isFinite(step) && step > 0 ? step : 1;
  }

  function getMin(input) {
    const min = parseFloat(input.getAttribute('min') || '1');
    return Number.isFinite(min) ? min : 1;
  }

  function getMax(input) {
    const raw = input.getAttribute('max');
    if (!raw) return Infinity;
    const max = parseFloat(raw);
    return Number.isFinite(max) ? max : Infinity;
  }

  function normalizeValue(input, value) {
    const min = getMin(input);
    const max = getMax(input);
    const step = getStep(input);

    let next = Number.isFinite(value) ? value : min;
    next = Math.max(min, Math.min(max, next));

    return next;
  }

  function setValue(input, value) {
    const finalValue = normalizeValue(input, value);
    input.value = String(finalValue);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // ⭐关键：阻止 product-card-link 抢事件
  document.addEventListener(
    'click',
    function (event) {
      const target = event.target;
      if (!(target instanceof Element)) return;

      if (!isInsideRefinedCard(target)) return;
      if (!isInteractive(target)) return;

      event.stopPropagation(); // 只阻止外层 link，不阻止内部组件
    },
    true
  );

  // ⭐pointerdown 也要拦
  document.addEventListener(
    'pointerdown',
    function (event) {
      const target = event.target;
      if (!(target instanceof Element)) return;

      if (!isInsideRefinedCard(target)) return;
      if (!isInteractive(target)) return;

      event.stopPropagation();
    },
    true
  );

  // blur 时修正输入
  document.addEventListener(
    'blur',
    function (event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;

      const input = target.closest(
        ".refined-product-card quantity-selector-component input[type='number']"
      );

      if (!input || input.disabled) return;

      const raw = parseFloat(input.value);
      setValue(input, raw);
    },
    true
  );

  // submit 前修正
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      if (!form.closest('.refined-product-card')) return;

      const selector = form.querySelector('quantity-selector-component');
      const input = getInput(selector);

      if (!input) return;

      const raw = parseFloat(input.value || '1');
      input.value = String(normalizeValue(input, raw));
    },
    true
  );
})();